__turbopack_context__.v({
  "root": "Skeleton-module__mgJKYG__root",
  "skeleton-loading": "Skeleton-module__mgJKYG__skeleton-loading",
  "spacedX": "Skeleton-module__mgJKYG__spacedX",
  "spacedY": "Skeleton-module__mgJKYG__spacedY",
});
